import React, {Component} from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import moment from 'moment';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import ComponentInfo from './ComponentInfo';
import DeliverableInfo from './DeliverableInfo';
import WorkPackageInfo from './WorkPackageInfo';
import { withStyles } from '@material-ui/core/styles';
import{ 
  NODE_TYPE_COMPONENT,NODE_TYPE_DELIVERABLE,NODE_TYPE_WORKPACKAGE,
  CREATE_PROJECT_MODEL_ACTION_SHOW,CREATE_PROJECT_MODEL_ACTION_CREATE
 } from '../common/redux/constantes';


//validators
import {validateField} from '../common/redux/validators';



  const styles = theme => ({
    
  });
 class NodeInformation extends Component {

  constructor(props){
    super(props);
    this.state = 
    {
      component:{tipo:NODE_TYPE_COMPONENT, project:this.props.project.project},
      deliverable:{tipo:NODE_TYPE_DELIVERABLE},
      workpackage:{tipo:NODE_TYPE_WORKPACKAGE},
      errores:{component:{}, deliverable:{}, workpackage:{}},
      addButtonDisable:false
    }


    


    //Bindings
    this.handleComponentChange = this.handleComponentChange.bind(this);
    this.handleDeliverableChange = this.handleDeliverableChange.bind(this);
    this.handleWorkPackageChange = this.handleWorkPackageChange.bind(this);
    this.callAction = this.callAction.bind(this);
    this.saveComponent = this.saveComponent.bind(this);
    this.saveDeliverable = this.saveDeliverable.bind(this);
    this.saveWorkpackage = this.saveWorkpackage.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.resetState = this.resetState.bind(this);
    this.onEnter = this.onEnter.bind(this);
    this.onExit = this.onExit.bind(this);
  }

  resetState()
  {
    this.setState({
      component:{tipo:NODE_TYPE_COMPONENT,project:this.props.project.project},
      deliverable:{tipo:NODE_TYPE_DELIVERABLE},
      workpackage:{tipo:NODE_TYPE_WORKPACKAGE},
      errores:{component:{}, deliverable:{}, workpackage:{}},
      addButtonDisable:false
    })
  }

  handleClose()
  {
    this.resetState();
    this.props.handleClose();
  }

  saveComponent()
  {
    //Validaciones de todos los campos
    if(!this.validateComponentForm())
    {
      return;
    }

    let new_node = this.state.component;//Nos ayudará a guardar el nodo que tenía antes
    let new_component =JSON.parse(JSON.stringify(this.state.component));//copiando el objeto
    delete new_component.tipo;
    if(this.props.actionDialog===CREATE_PROJECT_MODEL_ACTION_CREATE)
    {
      //Si está creando obtenemos el id de lo contrario lo dejamos como estaba
      new_component.component_father = this.props.parent.component;
    }

    //Vamos a editar/crear Component
    this.props.actions.saveComponent(new_component,this.props.actionDialog)
    .then(res=>{
      if(this.props.actionDialog===CREATE_PROJECT_MODEL_ACTION_CREATE){
        new_node.component = res.data.component.insertId;
        new_node.id = new_node.component;
        this.props.addNode(new_node);
      }else
      {
        new_node.tipo = NODE_TYPE_COMPONENT;
        new_node.children = this.props.parent.children;
        this.props.updateNode(new_node);
      }
    });
  }

  saveDeliverable()
  {
    //Validaciones de todos los campos
    if(!this.validateDeliverableForm()){
      return;
    }
    let new_node = this.state.deliverable;//Nos ayudará a guardar el nodo que tenía antes
    let new_deliverable =JSON.parse(JSON.stringify(this.state.deliverable)); //copiando el objeto
    delete new_deliverable.tipo;//Borrando el tipo para que no lo envíe al API ya que éste es de front end únicamente
    
    if(this.props.actionDialog===CREATE_PROJECT_MODEL_ACTION_CREATE)
    {
      //Si está creando obtenemos el id de lo contrario lo dejamos como estaba
      new_deliverable.component = this.props.parent.component;
    }

    if(new_deliverable.due_date)
      new_deliverable.due_date = moment(new_deliverable.due_date).format("YYYY-MM-DD");

    //Vamos a editar/crear Deliverable
    this.props.actions.saveDeliverable(new_deliverable,this.props.actionDialog)
    .then(res=>{
      if(this.props.actionDialog===CREATE_PROJECT_MODEL_ACTION_CREATE)
      {
        new_node.deliverable = res.data.deliverable.insertId;
        new_node.id = new_node.deliverable;
        new_node.name = res.data.deliverable.name;
        this.props.addNode(new_node);
      }else
      {
        new_node.tipo = NODE_TYPE_DELIVERABLE;
        new_node.children = this.props.parent.children;
        this.props.updateNode(new_node);
      }
    });
  }

  saveWorkpackage()
  {
    //Validaciones de todos los campos
    if(!this.validateWorkpackageForm()){
      return;
    }
    let new_node = this.state.workpackage;//Nos ayudará a guardar el nodo que tenía antes
    let new_workpackage =JSON.parse(JSON.stringify(this.state.workpackage));//copiando el objeto
    delete new_workpackage.tipo;//Borrando el tipo para que no lo envíe al API ya que éste es de front end únicamente
    
    if(this.props.actionDialog===CREATE_PROJECT_MODEL_ACTION_CREATE)
    {
      //Si está creando obtenemos el id de lo contrario lo dejamos como estaba
      new_workpackage.deliverable = this.props.parent.deliverable;
    }

    new_workpackage.due_date = moment(new_workpackage.due_date).format("YYYY-MM-DD");

    //Vamos a editar/crear Workpackage
    this.props.actions.saveWorkpackage(new_workpackage,this.props.actionDialog)
    .then(res=>{
      if(this.props.actionDialog===CREATE_PROJECT_MODEL_ACTION_CREATE){
        new_node.workpackage = res.data.workpackage.insertId;
        new_node.id = new_node.workpackage;
        this.props.addNode(new_node);
      }
      else
      {
        new_node.tipo = NODE_TYPE_WORKPACKAGE;
        this.props.updateNode(new_node);
      }
    });
  }



  callAction()
  {
    if(this.props.nodeType === NODE_TYPE_COMPONENT )
    {
      if(this.validateComponentForm())
        this.setState({addButtonDisable:true})
      //CALL API TO CREATE A COMPONENT
      this.saveComponent();
    }else if(this.props.nodeType === NODE_TYPE_DELIVERABLE)
    {

      if(this.validateDeliverableForm())
        this.setState({addButtonDisable:true})
      //CALL API TO CREATE A DELIVERABLE
      this.saveDeliverable();
    }else if(this.props.nodeType === NODE_TYPE_WORKPACKAGE)
    {

      if(this.validateWorkpackageForm())
        this.setState({addButtonDisable:true})
      //CALL API TO CREATE A WORKPACKAGE
      this.saveWorkpackage();
    }
  }

  handleComponentChange(event) 
  {
    //Si sólo se está mostrando la información no cambia nada.
    if(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )
      return;
    
    const target = event.target;
    const value = target.value;
    const name = target.id? target.id:target.name;

    let component = this.state.component;
    component[name] = value;
    this.setState({
      component:component,
    });
    this.validateComponentForm();
  }

  handleDeliverableChange(event) 
  {
    //Si sólo se está mostrando la información no cambia nada.
    if(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )
      return;
    const target = event.target;
    const value = target.value;
    const name = target.id? target.id:target.name;
    let deliverable = this.state.deliverable;
    deliverable[name] = value;
    this.setState({
      deliverable:deliverable,
    });
    this.validateDeliverableForm();
  }

  handleWorkPackageChange(event) 
  {
    //Si sólo se está mostrando la información no cambia nada.
    if(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )
      return;
    const target = event.target;
    const value = target.value;
    const name = target.id? target.id:target.name;
    let workpackage = this.state.workpackage;
    workpackage[name] = value;
    this.setState({
      workpackage:workpackage,
    });
    this.validateWorkpackageForm();
  }

  //Cada vez q entre al dialogo obtenemos la información
  onEnter()
  {
    this.getPreviewInfo();
    //Consultar los deliverables disponibles
    //Consultamos los catalogos
    this.props.actions.fetchDeliverableCatalog()
    .then(res=>{

      let deliverables = res.deliverable_catalogs.map(deliverable=>{
        let del = {};
        del.deliverable_catalog = del.value = deliverable.deliverable_catalog;
        del.name = del.label= deliverable.name;
        return del;
      })
      this.setState({deliverables: deliverables});
    });
  }

  //Si sale del diálogo entonces reseteamos toda configuracion que se hizo.
  onExit()
  {
    this.resetState();
    this.props.resetInformationConfig();
  }

  getPreviewInfo()
  {
    //Si no está creando entonces hay que mostrar la información que tiene el nodo.
    if(this.props.actionDialog!==CREATE_PROJECT_MODEL_ACTION_CREATE)
    {
      switch(this.props.parent.tipo)
      {
        case NODE_TYPE_COMPONENT:
          this.setState({
            component:{
              name:this.props.parent.name,
              component:this.props.parent.component,
              project:this.props.project.project,
              root:this.props.parent.root?this.props.parent.root:false
            }
          })
        break;
        case NODE_TYPE_DELIVERABLE:
          this.setState({
            deliverable:{
              name:this.props.parent.name,
              component:this.props.parent.component,
              description:this.props.parent.description,
              due_date:this.props.parent.due_date,
              deliverable:this.props.parent.deliverable
            }
          })
          break;
        case NODE_TYPE_WORKPACKAGE:
          this.setState({
            workpackage:{
              name:this.props.parent.name,
              workpackage:this.props.parent.workpackage,
              description:this.props.parent.description,
              due_date:this.props.parent.due_date,
              deliverable:this.props.parent.deliverable
            }
          })
          break;
        default:
          break;
      }
    }
  }


  validateComponentForm = ()=>
  {
    let errores = {
      component:{}
    };
    let valido = true;
    let component = {
      name:'',
    };

    //Validando atributos almenos ingresados
    for (const attribute in component) 
    {
      if (!validateField(this.state.component[attribute])) 
      {
        errores.component[attribute]= 'Required field';
        valido = false;
      }
    }


    this.setState({
      errores: errores,
    });
    return valido;
  }

  validateDeliverableForm = ()=>{
    let errores = {
      deliverable:{}
    };
    let valido = true;
    let deliverable = {
    };

    //Validando atributos almenos ingresados
    for (const attribute in deliverable) 
    {
      if (!validateField(this.state.deliverable[attribute])) 
      {
        errores.deliverable[attribute]= 'Required field';
        valido = false;
      }
    }
    if(!validateField(this.state.deliverable.name) && !validateField(this.state.deliverable.catalog))
    {
      errores.deliverable.name= 'Required field';
      errores.deliverable.catalog= 'Required field';
      valido = false;
    }


    this.setState({
      errores: errores,
    });
    return valido;
  }

  validateWorkpackageForm = ()=>{
    let errores = {
      workpackage:{}
    };
    let valido = true;
    let workpackage = {
      name:'',
    };

    //Validando atributos almenos ingresados
    for (const attribute in workpackage) 
    {
      if (!validateField(this.state.workpackage[attribute])) 
      {
        errores.workpackage[attribute]= 'Required field';
        valido = false;
      }
    }


    this.setState({
      errores: errores,
    });
    return valido;
  }

  getFormContent() 
  {
    // 0:NODE_TYPE_COMPONENT, 1: NODE_TYPE_DELIVERABLE, 2: NODE_TYPE_WORKPACKAGE 
    //Depende de que tipo de nodo mostraremos el formulario.
    switch (this.props.nodeType) 
    {
      case NODE_TYPE_COMPONENT:
        return <ComponentInfo  handleChange={this.handleComponentChange} errores={this.state.errores} component={this.state.component} reviewActive={(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )}/>;
      case NODE_TYPE_DELIVERABLE:
        return <DeliverableInfo  deliverables={this.state.deliverables} 
          handleChange={this.handleDeliverableChange} 
          errores={this.state.errores} 
          deliverable={this.state.deliverable} 
          reviewActive={(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )}
          actionDialog={this.props.actionDialog} />;
        case NODE_TYPE_WORKPACKAGE:
        return <WorkPackageInfo  handleChange={this.handleWorkPackageChange} errores={this.state.errores} workpackage={this.state.workpackage} reviewActive={(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )}/>;
      default:
        return null;
    }
    
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.props.open}
          aria-labelledby="form-dialog-title"
          onEnter={this.onEnter}
          onExit={this.onExit}
        >
          <React.Fragment>
            {this.getFormContent()}
          </React.Fragment>
          <DialogActions>
            {
              this.props.actionDialog!==CREATE_PROJECT_MODEL_ACTION_SHOW?
              (
                <div>
                <Button onClick={this.handleClose} color="primary">
                  Cancel
                </Button>
                <Button disabled={this.state.addButtonDisable} onClick={this.callAction} color="primary">
                  Add
                </Button>
                </div>
              ):
              (
                <Button onClick={this.handleClose} color="primary">
                  Close
                </Button>
              )
            }
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    wbs: state.wbs,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch)
{
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}



export default 
connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(NodeInformation));



// WEBPACK FOOTER //
// ./src/features/wbs/NodeInformation.js